<template>
  <div>
    <div class="search flex">
      <span class="tit">测试管理</span>
      <div class="flex">
        <el-button @click="toHistory" size="mini" class="addBtn">历史测试</el-button>
        <el-button @click="toAddExam" size="mini" class="addBtn">新增测试</el-button>
        <el-input class="addART" clearable
                  placeholder="标题、副标题"
                  v-model="page.name"
                  @change="skipPage(1)"
                  suffix-icon="el-icon-search">
        </el-input>
      </div>
    </div>
    <!-- header -->
    <div class="typeHead">
      <div class="medicineType flex">
        <span class="typeTit">筛选：</span>
        <div class="medicineTypeL">
                        <span><label :class="active.status==-1?'activeClass':''"
                                     @click="changeStatus(-1)">全部</label></span>
          <span><label :class="active.status==1?'activeClass':''"
                       @click="changeStatus(1)">开启</label></span>
          <span><label :class="active.status==0?'activeClass':''"
                       @click="changeStatus(0)">关闭</label></span>
        </div>
      </div>
      <div class="medicineType flex">
        <span class="typeTit">分类：</span>
        <div class="medicineTypeL">
          <span><label :class="active.type==-1?'activeClass':''" @click="changeType(-1)">全部</label></span>
          <span v-for="item in types" :key="item.id">
							<label :class="active.type==item.id?'activeClass':''"
                     @click="changeType(item.id)">{{ item.itemName }}</label>
						</span>
        </div>
      </div>
    </div>
    <div class="instrument">
      <!-- content table -->
      <el-table :data="page.rows" class="record-table"
                :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
                height="calc(100vh - 410px)"
                style="width: 100%;font-size:14px;color:#333;font-weight:400;margin-bottom: 10px;"
                max-height="calc(100vh - 410px)">
        <el-table-column prop="title" label="标题" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="subTitle" label="副标题" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="status" label="状态" width="100" align="center">
          <a href="javascript:;" slot-scope="scope" :class="scope.row.status==1?'green':'pink'" class="common"
             @click="updateStatus(scope.row)">
            {{ scope.row.status | statusFmt }}
          </a>
        </el-table-column>
        <el-table-column prop="exceptTime" label="预计时长" width="170" align="center"></el-table-column>
        <el-table-column prop="price" label="价格" width="100" align="center"></el-table-column>
        <el-table-column prop="majorPrice" label="分析价格" width="100" align="center"></el-table-column>
        <el-table-column prop="subjectCount" label="题目数" width="100" align="center"></el-table-column>
        <el-table-column prop="testedCount" label="已测人数" width="100" align="center"></el-table-column>
        <el-table-column prop="id" label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button @click="toEdit(scope.row.id)" type="text" size="small" class="btn">编辑</el-button>
            <el-button @click="toDetails(scope.row.id)" type="text" size="small" class="btn">详情</el-button>
            <el-button @click="del(scope.row.id)" type="text" size="small" class="btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- foot pagination -->
      <el-pagination
          class="pagination"
          :hide-on-single-page="true"
          background
          prev-text="Prev"
          next-text="Next"
          @current-change="skipPage"
          :current-page="page.current"
          :page-size="page.size"
          layout="prev, pager, next"
          :total="page.total">
      </el-pagination>
    </div>
    <!-- dialog edit -->
    <!--    新增编辑-->
    <el-drawer :visible.sync="editDialog.show"
               :title="editDialog.title+'测试'"
               :wrapperClosable="false" :close-on-press-escape="false"
               :show-close="false" size="800px" class="drawerCommon"
               @close="handleEditClose">
      <div class="maxHeight">
        <el-divider><span style="font-weight: bold">基本信息</span></el-divider>
        <!-- 基本信息form -->
        <el-form :model="editForm" label-width="90px" label-suffix="：">
          <el-form-item label="标题">
            <el-input v-model="editForm.title"></el-input>
          </el-form-item>
          <el-form-item label="副标题">
            <el-input v-model="editForm.subTitle"></el-input>
          </el-form-item>
          <el-form-item label="展示图">
            <el-upload name="uploadFile"
                       :action="uploadUrl"
                       :accept="'image/*'"
                       :show-file-list="false"
                       :on-success="handleUploadSuccess"
                       :on-error="handleUploadError"
                       class="avatar-uploader">
              <img v-if="editForm.exhibitImg" :src="editForm.exhibitImg" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="分类">
            <el-select v-model="editForm.examType" placeholder="请选择分类">
              <el-option v-for="item in types"
                         :label="item.itemName"
                         :value="item.id"
                         :key="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="预计时长">
            <el-input v-model="editForm.exceptTime"></el-input>
          </el-form-item>
          <el-form-item label="价格">
            <el-input type="number" v-model="editForm.price"></el-input>
          </el-form-item>
          <el-form-item label="专业价格">
            <el-input type="number" v-model="editForm.majorPrice"></el-input>
          </el-form-item>
          <el-form-item label="简介">
            <el-input type="textarea" rows="4" v-model="editForm.briefDesc"></el-input>
          </el-form-item>
        </el-form>
        <template v-if="editDialog.title === '新增'">
          <el-divider><span style="font-weight: bold">题目信息</span></el-divider>
          <!-- 题目 info -->
          <div class="subjects">
            <section v-for="(subjectItem,index) in editForm.subjects" :key="index">
              <h5 class="flex" style="align-items: normal">
                <span class="subjectType">{{ subjectItem.subjectType | subjectTypeFmt }}</span>
                <span class="title">{{ index + 1 }}. {{ subjectItem.title }}</span>
                <el-button size="mini" class="option-remove" @click="removeSubject(index)">删除</el-button>
              </h5>
              <div class="options" v-if="subjectItem.subjectType != 4 && subjectItem.subjectType != 5">
                <p v-for="(optionItem,o_index) in subjectItem.options" :key="o_index">
                  选项{{ o_index + 1 }}. {{ optionItem.title }} ({{ optionItem.score }}分)
                </p>
              </div>
            </section>
          </div>
          <!-- 题目form -->
          <el-form label-width="90px" label-suffix="：">
            <el-form-item label="题目">
              <el-input v-model="subjectTemplate.title"></el-input>
            </el-form-item>
            <el-form-item label="类型">
              <el-radio-group v-model="subjectTemplate.subjectType" @change="handleSubjectTypeChange">
                <el-radio :label="'1'">单选</el-radio>
                <el-radio :label="'2'">判断</el-radio>
                <el-radio :label="'3'">多选</el-radio>
                <el-radio :label="'4'">填空</el-radio>
                <el-radio :label="'5'">问答</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- 单选、多选 -->
            <template v-if="subjectTemplate.subjectType == 1 || subjectTemplate.subjectType == 3">
              <el-button size="small" class="option-add" @click="addOption">添加选项</el-button>
              <el-form-item :label="'选项'+ (index+1)" v-for="(optionItem,index) in subjectTemplate.options"
                            :key="index">
                <el-input class="option-title" v-model="optionItem.title"></el-input>
                <span class="option-label">分数：</span>
                <el-input type="number" min="0" class="option-score" v-model="optionItem.score"></el-input>
                <i class="el-icon-error option-remove" style="margin-left: 10px;cursor: pointer"
                   @click="removeOption(index)"></i>
              </el-form-item>
            </template>
            <!-- 判断 -->
            <template v-if="subjectTemplate.subjectType == 2">
              <el-form-item :label="'选项'+ (index+1)" v-for="(optionItem,index) in subjectTemplate.options"
                            :key="index">
                <el-input class="option-title" v-model="optionItem.title"></el-input>
                <span class="option-label">分数：</span>
                <el-input class="option-score" v-model="optionItem.score"></el-input>
              </el-form-item>
            </template>
            <el-button size="small" class="option-add" @click="addSubject">添加题目</el-button>
          </el-form>
        </template>
        <el-divider><span style="font-weight: bold">分析结果</span></el-divider>
        <div class="subjects">
          <div v-for="(analysis,analysis_index) in editForm.analyses" :key="analysis_index">
            <div class="flex">
              <h4 class="title"><span class="maxW">分值区间：</span>{{ analysis.scoreRangeMin }} - {{
                  analysis.scoreRangeMax
                }}</h4>
              <el-button size="mini" class="option-remove" @click="removeAnalysis(analysis_index)">删除</el-button>
            </div>
            <p class="res-desc"><span class="maxW">结果：</span>{{ analysis.title }}</p>
            <p class="res-desc" v-if="analysis.analysisDesc"><span class="maxW">详细说明：</span>{{ analysis.analysisDesc }}
            </p>
          </div>
        </div>

        <!-- 题目的分析结果信息 -->
        <el-form label-width="90px" label-suffix="：">
          <div style="text-align: center;margin:20px auto; color: #F44336;">tips: 分析结果分值范围包含最小值,不包括最大值</div>
          <el-form-item label="分值范围">
            <el-input type="number" min="0" v-model="analysisTemplate.scoreRangeMin"
                      class="score-range"></el-input>
            <span> - </span>
            <el-input type="number" min="0" v-model="analysisTemplate.scoreRangeMax"
                      class="score-range"></el-input>
          </el-form-item>
          <el-form-item label="结果">
            <el-input style="width: 70%" v-model="analysisTemplate.title"></el-input>
          </el-form-item>
          <el-form-item label="详细说明">
            <el-input type="textarea" rows="4" placeholder="分析结果的详细说明"
                      v-model="analysisTemplate.analysisDesc"></el-input>
          </el-form-item>
          <el-button size="small" class="option-add" @click="addAnalysis">添加分析结果</el-button>
        </el-form>
      </div>
      <div class="footer">
        <el-button size="small" v-if="editDialog.title === '新增'" type="primary" @click="save" :loading="formLoading">
          保存
        </el-button>
        <el-button size="small" v-else type="primary" @click="saveModify" :loading="formLoading">保存</el-button>
        <el-button size="small" @click="editDialog.show=false">取消</el-button>
      </div>
    </el-drawer>
    <!--    <el-dialog :visible.sync="modifyDialog.show"
                   :title="modifyDialog.title"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   width="70%"
                   top="70px"
                   @close="handleEditClose">
          <el-divider><span style="font-weight: bold">基本信息</span></el-divider>
          &lt;!&ndash; 基本信息form &ndash;&gt;
          <el-form :model="editForm" label-width="80px">
            <el-form-item label="标题">
              <el-input v-model="editForm.title"></el-input>
            </el-form-item>
            <el-form-item label="副标题">
              <el-input v-model="editForm.subTitle"></el-input>
            </el-form-item>
            <el-form-item label="展示图">
              <el-upload name="uploadFile"
                         :action="uploadUrl"
                         :accept="'image/*'"
                         :show-file-list="false"
                         :on-success="handleUploadSuccess"
                         :on-error="handleUploadError"
                         class="avatar-uploader">
                <img v-if="editForm.exhibitImg" :src="editForm.exhibitImg" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="分类">
              <el-select v-model="editForm.examType" placeholder="请选择分类">
                <el-option v-for="item in types"
                           :label="item.itemName"
                           :value="item.id"
                           :key="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="预计时长">
              <el-input v-model="editForm.exceptTime"></el-input>
            </el-form-item>
            <el-form-item label="价格">
              <el-input type="number" v-model="editForm.price"></el-input>
            </el-form-item>
            <el-form-item label="专业价格">
              <el-input type="number" v-model="editForm.majorPrice"></el-input>
            </el-form-item>
            <el-form-item label="简介">
              <el-input type="textarea" rows="4" v-model="editForm.briefDesc"></el-input>
            </el-form-item>
          </el-form>

          <el-divider><span style="font-weight: bold">分析结果</span></el-divider>
          <div class="res">
            <p v-for="(analysis,analysis_index) in editForm.analyses" :key="analysis_index">
              <span class="res-range">({{ analysis.scoreRangeMin }} - {{ analysis.scoreRangeMax }})</span>
              <i class="el-icon-error option-remove" @click="removeAnalysis(analysis_index)"></i>
              <span class="res-title">{{ analysis.title }}</span>
              <span class="res-desc">{{ analysis.analysisDesc }}</span>
            </p>
          </div>

          &lt;!&ndash; 题目的分析结果信息 &ndash;&gt;
          <el-form label-width="120px">
            <div style="padding-left: 120px; color: #F44336;">tips: 分析结果分值范围包含最小值,不包括最大值</div>
            <el-form-item label="分值范围">
              <el-input type="number" min="0" v-model="analysisTemplate.scoreRangeMin"
                        class="score-range"></el-input>
              <span>-</span>
              <el-input type="number" min="0" v-model="analysisTemplate.scoreRangeMax"
                        class="score-range"></el-input>
              <span style="margin: 0 4px 0 8px">结果:</span>
              <el-input style="width: 70%" v-model="analysisTemplate.title"></el-input>
            </el-form-item>
            <el-form-item label="详细说明">
              <el-input type="textarea" rows="4" placeholder="分析结果的详细说明"
                        v-model="analysisTemplate.analysisDesc"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" plain style="padding: 6px" @click="addAnalysis">添加分析结果</el-button>
            </el-form-item>
          </el-form>

          <template slot="footer">
            <el-button style="width: 90px;" type="primary" @click="saveModify" :loading="formLoading">保存</el-button>
            <el-button style="width: 90px;margin-left: 20px" @click="modifyDialog.show=false">取消</el-button>
          </template>
        </el-dialog>-->
  </div>
</template>

<script>
import base from '@/api/common';

export default {
  name: "exam_manage",
  data() {
    return {
      uploadUrl: base.uploadUrl + 'exam',
      active: {
        status: -1,
        type: 0,
      },
      types: [],
      page: {
        current: 1,
        size: 10,
        total: 6,
        rows: [],

        name: '',
      },

      editDialog: {
        show: false,
        title: '',
      },
      modifyDialog: {
        show: false,
        title: '',
      },
      editForm: {
        id: '',
        title: '',
        subTitle: '',
        exhibitImg: '',
        exceptTime: '',
        price: 0.0,
        majorPrice: 0.0,
        briefDesc: '',
        examType: '',
        subjects: [], // 题目s
        analyses: [],
      },

      /* 题目模板form */
      subjectTemplate: {
        title: '',
        subjectType: '1',
        options: [
          {
            title: '',
            score: 0
          }
        ],
      },
      /* 分析结果模板form */
      analysisTemplate: {
        scoreRangeMin: 0,
        scoreRangeMax: 5,
        title: '',
        analysisDesc: ''
      },
      formLoading: false
    }
  },
  mounted() {
    // 加载分类
    this.$ajax.get(base.api.dict.exam.type).then((res) => {
      if (res.data.status === 'success') {
        this.types = this.types.concat(res.data.list);
      }
    });
    // 加载默认数据
    this.skipPage(1);
  },
  methods: {
    removeItemById(id) {
      if (id) {
        let index = -1;
        $(this.page.rows).each((i, o) => {
          if (id == o.id) {
            index = i;
            return false;
          }
        });
        if (index >= 0) {
          this.page.rows.splice(index, 1);
        }
      }
    },
    skipPage(cur) {
      this.page.current = cur;
      let data = {
        current: this.page.current,
        size: this.page.size,
        examStatus: this.page.status,
        examType: this.page.type,
        name: this.page.name
      };
      this.$ajax.get(base.manager_api.exam.page, {params: data}).then(res => {
        if (res.data.status === 'success') {
          this.page.current = res.data.current;
          this.page.size = res.data.size;
          this.page.total = res.data.total;
          this.page.rows = res.data.rows;
        } else {
          this.$message.error("数据加载失败");
        }
      }).catch(err => {
        this.$message.error("数据加载失败");
        console.error(err);
      });
    },
    changeStatus(status) {
      this.active.status = status;
      this.page.status = status;
      this.skipPage(1);
    },
    changeType(type) {
      this.active.type = type;
      this.page.type = type;
      this.skipPage(1);
    },
    toEdit(id) {
      this.editDialog.title = "编辑";
      this.editDialog.show = true;
      // this.modifyDialog.show = true;
      // 加载details数据
      this.$ajax.get(base.manager_api.exam.details.replace("{id}", id)).then(res => {
        if (res.data.status === 'success') {
          this.editForm.id = id;
          this.editForm.title = res.data.data.title;
          this.editForm.subTitle = res.data.data.subTitle;
          this.editForm.exhibitImg = res.data.data.exhibitImg;
          this.editForm.exceptTime = res.data.data.exceptTime;
          this.editForm.price = res.data.data.price;
          this.editForm.majorPrice = res.data.data.majorPrice;
          this.editForm.briefDesc = res.data.data.briefDesc;
          this.editForm.examType = res.data.data.examType;
        } else {
          this.$message.error("信息加载失败");
        }
      });
      // 加载系统分析结果信息
      this.$ajax.get(base.api.exam.analysis.replace("{id}", id)).then(res => {
        if (res.data.status === 'success') {
          this.editForm.analyses = res.data.list;
        } else {
          this.$message.error("信息加载失败");
        }
      });
    },
    toAddExam() {
      this.editDialog.title = "新增";
      this.editDialog.show = true;
    },
    toDetails(id) {
      window.open("/admin/exam/details/" + id, '_blank')
    },
    handleEditClose() {
      this.editForm.id = '';
      this.editForm.title = '';
      this.editForm.subTitle = '';
      this.editForm.exhibitImg = '';
      this.editForm.exceptTime = '';
      this.editForm.price = 0.0;
      this.editForm.majorPrice = 0.0;
      this.editForm.briefDesc = '';
      this.editForm.examType = '';
      this.editForm.subjects.length = 0;
      this.editForm.analyses.length = 0;
    },
    handleUploadSuccess(res, file, fileList) {
      if (res.status === 'success') {
        this.editForm.exhibitImg = res.message;
      } else {
        this.$message.error("图片上传失败");
        this.editForm.exhibitImg = "";
      }
    },
    handleUploadError(event, file, fileList) {
      this.$message.error("图片上传失败");
      this.editForm.exhibitImg = "";
    },
    del(id) {
      if (id) {
        let that = this;
        this.$messageBox.confirm("确定要删除吗?", "删除确认", {type: 'warning'}).then(_ => {
          that.$ajax.post(base.manager_api.exam.del.replace("{id}", id)).then(res => {
            if (res.data.status === 'success') {
              this.$message.success("删除成功");
              this.removeItemById(id);
            } else {
              this.$message.error(res.data.message)
            }
          }).catch(err => {
            console.error(err);
            this.$message.error("操作失败");
          });
        });
      }
    },
    updateStatus(item) {
      if (item && item.id) {
        let msg = '是否' + (item.status == 1 ? '关闭' : '开启');
        let targetStatus = (item.status + 1) % 2;
        this.$messageBox.confirm(msg, '提示', {type: 'warning'}).then(_ => {
          this.$ajax.post(base.manager_api.exam.changeStatus.replace("{id}", item.id) + "?status=" + targetStatus).then(res => {
            if (res.data.status === 'success') {
              this.$message.success("操作成功");
              item.status = targetStatus;
            } else {
              this.$message.error(res.data.message);
            }
          }).catch(err => {
            console.error(err);
            this.$message.error("操作失败");
          });

        });
      }
    },
    handleSubjectTypeChange(val) {
      this.subjectTemplate.options.length = 0;
      this.subjectTemplate.options.push({
        title: '',
        score: 0
      });
      if (val == 2) { //判断题
        this.subjectTemplate.options.push({
          title: '',
          score: 0
        });
        this.subjectTemplate.options.length = 2;
      }
    },
    resetSubjectTemplate() {
      this.subjectTemplate.title = '';
      this.subjectTemplate.subjectType = '1';
      this.subjectTemplate.options.length = 0;
      this.subjectTemplate.options.push({
        title: '',
        score: 0
      });
    },
    addOption() {
      let length = this.subjectTemplate.options.length;
      if (length >= 10) {
        this.$message.warning("最多10个选项");
        return;
      }
      this.subjectTemplate.options.push({
        title: '',
        score: 0
      });
    },
    removeSubject(index) {
      this.$messageBox.confirm('确定要移除这个题目吗?', '删除提示', {type: 'warning'}).then(_ => {
        this.editForm.subjects.splice(index, 1);
      })
    },
    removeOption(index) {
      this.subjectTemplate.options.splice(index, 1);
    },
    addSubject() {
      let that = this;
      if ($.trim(this.subjectTemplate.title).length === 0) {
        this.$message.warning('题目内容不能为空');
        return;
      }
      let optionLength = this.subjectTemplate.options.length;
      let subjectType = this.subjectTemplate.subjectType;
      if ((subjectType == 1 | subjectType == 3) && optionLength < 2) {
        this.$message.warning('单/多选题目选项至少两个');
        return;
      }


      if (subjectType != 4 && subjectType != 5) {
        let check = true;
        $(this.subjectTemplate.options).each((i, o) => {
          if ($.trim(o.title).length === 0) {
            check = false;
            that.$message.warning("选项" + (i + 1) + "内容不能为空");
            return false;
          }
          if (o.score < 0) {
            check = false;
            that.$message.warning("选项分数不能小于0");
            return false;
          }
        });
        if (!check) {
          return;
        }
      }

      let subject = {
        title: this.subjectTemplate.title,
        subjectType: this.subjectTemplate.subjectType,
        options: [],
      };
      if (subjectType == 1 || subjectType == 2 || subjectType == 3) {
        subject.options = subject.options.concat(this.subjectTemplate.options);
      }
      this.editForm.subjects.push(subject);
      that.resetSubjectTemplate();
    },
    addAnalysis() {
      let min = Number(this.analysisTemplate.scoreRangeMin);
      let max = Number(this.analysisTemplate.scoreRangeMax);
      if (min >= max) {
        this.$message.warning("分值范围错误");
        return;
      }
      if ($.trim(this.analysisTemplate.title).length === 0) {
        this.$message.warning("分析结果不能为空");
        return;
      }
      let analysis = {
        scoreRangeMin: min,
        scoreRangeMax: max,
        title: this.analysisTemplate.title,
        analysisDesc: this.analysisTemplate.analysisDesc
      };
      this.editForm.analyses.push(analysis);
      // 添加成功后重置form内容
      this.analysisTemplate.scoreRangeMin = max;
      this.analysisTemplate.scoreRangeMax = max + 5;
      this.analysisTemplate.title = "";
      this.analysisTemplate.analysisDesc = '';
    },
    removeAnalysis(index) {
      this.$messageBox.confirm('确定要移除这个结果吗?', '删除提示', {type: 'warning'}).then(_ => {
        this.editForm.analyses.splice(index, 1);
      })
    },
    save() {
      if ($.trim(this.editForm.title).length === 0) {
        this.$message.warning("标题不能为空");
        return;
      }
      if (!this.editForm.examType) {
        this.$message.warning("请选择分类");
        return;
      }

      if ($.trim(this.editForm.exhibitImg).length === 0) {
        this.$message.warning("展示图不能为空");
        return;
      }
      if ($.trim(this.editForm.exceptTime).length === 0) {
        this.$message.warning("请输入预计时长");
        return;
      }
      if (this.editForm.price < 0) {
        this.$message.warning("价格输入有误");
        return;
      }
      if(this.editForm.majorPrice <= 0){
        this.$message.warning('专业价格不能低于0');
        return;
      }
      if (this.editForm.subjects.length === 0) {
        this.$message.warning("未添加题目");
        return;
      }
      this.formLoading = true;
      this.$ajax.post(base.manager_api.exam.add, this.editForm).then(res => {
        this.formLoading = false;
        if (res.data.status === 'success') {
          this.$message.success("添加成功");
          this.editDialog.show = false;
        } else {
          this.$message.error(res.data.message);
        }
      }).catch(err => {
        console.error(err);
        this.$message.error("操作失败");
      })
    },
    saveModify() {
      if ($.trim(this.editForm.title).length === 0) {
        this.$message.warning("标题不能为空");
        return;
      }
      if (!this.editForm.examType) {
        this.$message.warning("请选择分类");
        return;
      }
      if ($.trim(this.editForm.exhibitImg).length === 0) {
        this.$message.warning("展示图不能为空");
        return;
      }
      if ($.trim(this.editForm.exceptTime).length === 0) {
        this.$message.warning("请输入预计时长");
        return;
      }
      if (this.editForm.price < 0) {
        this.$message.warning("价格输入有误");
        return;
      }
      if(this.editForm.majorPrice <= 0){
        this.$message.warning('专业价格不能低于0');
        return;
      }
      this.formLoading = true;
      if (this.editForm.id) {
        this.$ajax.post(base.manager_api.exam.update.replace("{id}", this.editForm.id), this.editForm).then(res => {
          this.formLoading = false;
          if (res.data.status === 'success') {
            this.editDialog.show = false;
            this.$message.success("操作成功");
          } else {
            this.$message.error(res.data.message);
          }
        }).catch(err => {
          this.$message.error("操作失败");
          console.error(err);
        })

      }
    },
    toHistory() {
      this.$router.push({path: 'history/list'})
    }
  },
  filters: {
    statusFmt(status) {
      if (status || status == 0) {
        if (status == 0) {
          return "关闭";
        } else if (status == 1) {
          return "开启";
        }
      }
      return "-";
    },
    subjectTypeFmt(type) {
      if (type) {
        type = Number(type);
        switch (type) {
          case 1:
            return '单选题';
          case 2:
            return '判断题';
          case 3:
            return '多选题';
          case 4:
            return '填空题';
          case 5:
            return '问答题';
        }
      }
      return '';
    },

  }
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/admin.scss';

div[data-state] {
  cursor: pointer
}

div[data-state='1'] {
  color: #a4da89;
  background-color: #f0f9eb;
  border-color: #e1f3d8;
}

div[data-state='0'] {
  color: #f9a7a7;
  background-color: #fef0f0;
  border-color: #fde2e2;
}


::v-deep div.el-dialog {
  .el-dialog__body {
    max-height: calc(100vh - 280px) !important;
    min-height: 100px;
    overflow-y: scroll;
  }
}

::v-deep .el-dialog__wrapper {
  overflow: unset
}

::v-deep .ql-snow .ql-picker.ql-header .ql-picker-label::before, .ql-snow .ql-picker.ql-header .ql-picker-item::before {
  position: relative;
  top: -8px
}

/* 新增时展示图css */
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 160px;
  height: 160px;
  line-height: 160px;
  text-align: center;
  border: 1px dashed #ccc;
}

img.avatar {
  height: 160px;
  display: block;
}

.option-add {
  margin: 0 0 20px 90px;
  color: #567BFF;
  font-size: 14px;
  border-color: #567BFF;
  background: #ffffff;
}

::v-deep .el-input__inner[type="number"] {
  padding-right: 0;
}

.option-remove {
  color: #567BFF;
  border-color: #567BFF;
  height: 30px;
}

.option-title {
  width: 75%
}

.option-score {
  width: 10%
}

.option-label {
  margin-left: 10px
}

.score-range {
  width: 14%
}

</style>
